import { FetchRequest } from '@rails/request.js';
import AxisLockedSortableController from './axis_locked_sortable_base';

const SECTION = '.billable-section';
const PINNED = '.billable-section--unassigned, .billable-section--pending';

export default class extends AxisLockedSortableController {
  _groupOptions() {
    return {
      group: { name: 'billable-sections', pull: false, put: false },
    };
  }

  _extraOptions() {
    return {
      filter: PINNED,
      preventOnFilter: false,
      onMove: (event) => !event.related.matches(PINNED),
    };
  }

  _updateSortOrder(event) {
    return this.#persist(event.item, event.oldIndex);
  }

  async #persist(section, indexBeforeDrag) {
    this.#clearError(section);

    const body = new FormData();
    body.append('position', this.#positionOf(section));
    const request = new FetchRequest('patch', section.dataset.reorderUrl, { body });

    try {
      const response = await request.perform();
      if (!response.ok) {
        this.#revert(section, indexBeforeDrag);
      }
    } catch (error) {
      console.error(error);
      this.#revert(section, indexBeforeDrag);
    }
  }

  #positionOf(section) {
    return this.#reorderableSections.indexOf(section);
  }

  get #reorderableSections() {
    return [...this.element.querySelectorAll(`:scope > ${SECTION}:not(${PINNED})`)];
  }

  #revert(section, indexBeforeDrag) {
    const anchor = this.#siblingsWithout(section)[indexBeforeDrag];

    this.element.insertBefore(section, anchor ?? null);
    this.#showError(section);
  }

  #siblingsWithout(section) {
    return [...this.element.children].filter((element) => element !== section);
  }

  #showError(section) {
    const error = section.querySelector('.billable-section__reorder-error');

    if (error) {
      error.hidden = false;
    }
  }

  #clearError(section) {
    const error = section.querySelector('.billable-section__reorder-error');

    if (error) {
      error.hidden = true;
    }
  }
}
